var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40050",
    "data-name": "Group 40050",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15757",
    "data-name": "Rectangle 15757",
    width: 17,
    height: 11,
    fill: "#878a99"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40050-2",
    "data-name": "Group 40050",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82662",
    "data-name": "Path 82662",
    d: "M17,5.635c-.387.488-.749,1-1.166,1.458a13.994,13.994,0,0,1-3.288,2.7A8.363,8.363,0,0,1,9.3,10.951a7.111,7.111,0,0,1-3.8-.62A12.759,12.759,0,0,1,1.565,7.5C1.08,7,.637,6.464.187,5.931a.594.594,0,0,1,0-.865A15.3,15.3,0,0,1,4.459,1.205,8.285,8.285,0,0,1,7.684.05a7.076,7.076,0,0,1,3.737.584A12.706,12.706,0,0,1,15.44,3.5c.481.494.917,1.034,1.368,1.557a2.252,2.252,0,0,1,.192.31ZM1.257,5.49c.347.381.652.736.978,1.071A12.029,12.029,0,0,0,5.984,9.288a6.32,6.32,0,0,0,2.221.56,6.491,6.491,0,0,0,3.4-.838A12.565,12.565,0,0,0,14.736,6.6c.341-.35.659-.722,1-1.1-.32-.353-.615-.7-.927-1.019a12.08,12.08,0,0,0-3.781-2.767,6.323,6.323,0,0,0-2.22-.563,6.5,6.5,0,0,0-3.4.834A11.831,11.831,0,0,0,2.632,4.043c-.469.458-.905.95-1.375,1.447",
    transform: "translate(0 0)",
    fill: "#878a99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82663",
    "data-name": "Path 82663",
    d: "M127.073,49.479a3.412,3.412,0,1,1-3.363,3.414,3.388,3.388,0,0,1,3.363-3.414m-.005,1.145a2.267,2.267,0,1,0,2.234,2.265,2.243,2.243,0,0,0-2.234-2.265",
    transform: "translate(-118.567 -47.391)",
    fill: "#878a99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.c47b01fd180facbad3b81b7f78f018c5.svg";
export { ForwardRef as ReactComponent };